import { FirebaseApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  addDoc,
  collection,
  getFirestore,
  onSnapshot,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

// Function to create a Stripe Checkout session and get the URL
export const getCheckoutUrl = async (
  app: FirebaseApp,
  priceId: string
): Promise<string> => {

  const auth = getAuth(app);
  const userId = auth.currentUser?.uid;
  // Ensure user is authenticated
  if (!userId) throw new Error("User is not authenticated");

  const db = getFirestore(app);

  //Adds a document to customers/{userId}/checkout_sessions (used by Stripe extension).
  const checkoutSessionRef = collection(
    db,
    "customers",
    userId,
    "checkout_sessions"
  );

  //Listens for Firestore updates on that document.
//Stripe extension writes url when the checkout session is ready.
  const docRef = await addDoc(checkoutSessionRef, {
    price: priceId,
    success_url: window.location.origin +'/for-you',
    cancel_url: window.location.origin +'/for-you',
  });

  //Returns the URL so you can redirect the user to Stripe Checkout.
  return new Promise<string>((resolve, reject) => {
    const unsubscribe = onSnapshot(docRef, (snap) => {
      const { error, url } = snap.data() as {
        error?: { message: string };
        url?: string;
      };
      if (error) {
        unsubscribe();
        reject(new Error(`An error occurred: ${error.message}`));
      }
      if (url) {
        console.log("Stripe Checkout URL:", url);
        unsubscribe();
        resolve(url);
      }
    });
  });
};

// Function to create a Stripe Customer Portal session and get the URL
export const getPortalUrl = async (app: FirebaseApp): Promise<string> => {
  const auth = getAuth(app);
  const user = auth.currentUser;

  let dataWithUrl: any;
  try {
    const functions = getFunctions(app, "us-central1");
    const functionRef = httpsCallable(
      functions,
      "ext-firestore-stripe-payments-createPortalLink"
    );
    const { data } = await functionRef({
      customerId: user?.uid,
      returnUrl: window.location.origin,
    });

    // Add a type to the data
    dataWithUrl = data as { url: string };
    console.log("Reroute to Stripe portal: ", dataWithUrl.url);
  } catch (error) {
    console.error(error);
  }

  return new Promise<string>((resolve, reject) => {
    if (dataWithUrl.url) {
      resolve(dataWithUrl.url);
    } else {
      reject(new Error("No url returned"));
    }
  });
};